module.exports = __webpack_public_path__ + "img/thumb-de-hair-je-ne-veux.fc011dfa.jpg";